import React, { useState } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CNav,
    CNavItem,
    CNavLink,
    CForm,
    CFormInput,
    CFormLabel,
    CButton,
    CRow,
    CCol,
    CAlert,
} from '@coreui/react-pro';
import SessionsTab from './SessionsTab';

export const UserProfilePage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'info' | 'security' | 'sessions'>('info');

    // Datos personales del Administrador de la Tienda
    const [userInfo, setUserInfo] = useState({
        name: 'Carlos Mendoza',
        email: 'carlos.mendoza@burgerhouse.com',
        phone: '300 456 7890',
        role: 'Administrador de Comercio',
    });

    // Cambio de contraseña
    const [passwords, setPasswords] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    return (
        <CCard className="border border-secondary-subtle shadow-none mb-4 bg-body rounded-3">
            <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3 text-body">
                <h6 className="mb-2 fw-bold">
                    Mi Perfil de Usuario (Administrador)
                </h6>
                <CNav variant="tabs" className="card-header-tabs border-0 mt-2">
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'info'}
                            onClick={() => setActiveTab('info')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'info'
                                    ? 'text-body fw-bold border-bottom border-2 border-dark'
                                    : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Datos Personales
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'security'}
                            onClick={() => setActiveTab('security')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'security'
                                    ? 'text-body fw-bold border-bottom border-2 border-dark'
                                    : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Seguridad y Contraseña
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'sessions'}
                            onClick={() => setActiveTab('sessions')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'sessions'
                                    ? 'text-body fw-bold border-bottom border-2 border-dark'
                                    : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Sesiones Activas
                        </CNavLink>
                    </CNavItem>
                </CNav>
            </CCardHeader>

            <CCardBody className="p-4 bg-body text-body">
                {/* TAB 1: DATOS PERSONALES */}
                {activeTab === 'info' && (
                    <CForm>
                        <div className="d-flex align-items-center gap-3 mb-4 p-3 bg-body-tertiary border border-secondary-subtle rounded-3">
                            <div
                                className="bg-body text-body border border-secondary-subtle rounded-circle d-flex align-items-center justify-content-center fw-bold fs-5 shadow-sm"
                                style={{ width: '52px', height: '52px' }}
                            >
                                CM
                            </div>
                            <div>
                                <h6 className="fw-semibold text-body mb-1">{userInfo.name}</h6>
                                <span className="badge bg-body text-body-secondary border border-secondary-subtle rounded-pill font-normal">
                                    {userInfo.role}
                                </span>
                            </div>
                        </div>

                        <CRow className="g-3 mb-4">
                            <CCol md={6}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Nombre Completo</CFormLabel>
                                <CFormInput
                                    className="bg-body text-body border-secondary-subtle"
                                    value={userInfo.name}
                                    onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Correo Electrónico de Acceso</CFormLabel>
                                <CFormInput
                                    type="email"
                                    className="bg-body text-body border-secondary-subtle"
                                    value={userInfo.email}
                                    onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })}
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Teléfono Celular</CFormLabel>
                                <CFormInput
                                    className="bg-body text-body border-secondary-subtle"
                                    value={userInfo.phone}
                                    onChange={(e) => setUserInfo({ ...userInfo, phone: e.target.value })}
                                />
                            </CCol>
                        </CRow>

                        <div className="d-flex justify-content-end">
                            <CButton color="dark" className="px-4 fw-medium text-white">
                                Guardar Cambios
                            </CButton>
                        </div>
                    </CForm>
                )}

                {/* TAB 2: CAMBIO DE CONTRASEÑA */}
                {activeTab === 'security' && (
                    <CForm>
                        <CAlert color="secondary" className="mb-4 border border-secondary-subtle text-body-secondary bg-body-tertiary small">
                            Asegúrate de ingresar una contraseña segura de al menos 8 caracteres.
                        </CAlert>

                        <CRow className="g-3 mb-4" style={{ maxWidth: '500px' }}>
                            <CCol md={12}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Contraseña Actual</CFormLabel>
                                <CFormInput
                                    type="password"
                                    className="bg-body text-body border-secondary-subtle"
                                    value={passwords.currentPassword}
                                    onChange={(e) => setPasswords({ ...passwords, currentPassword: e.target.value })}
                                />
                            </CCol>
                            <CCol md={12}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Nueva Contraseña</CFormLabel>
                                <CFormInput
                                    type="password"
                                    className="bg-body text-body border-secondary-subtle"
                                    value={passwords.newPassword}
                                    onChange={(e) => setPasswords({ ...passwords, newPassword: e.target.value })}
                                />
                            </CCol>
                            <CCol md={12}>
                                <CFormLabel className="small fw-semibold text-body-secondary mb-1">Confirmar Nueva Contraseña</CFormLabel>
                                <CFormInput
                                    type="password"
                                    className="bg-body text-body border-secondary-subtle"
                                    value={passwords.confirmPassword}
                                    onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })}
                                />
                            </CCol>
                        </CRow>

                        <div className="d-flex justify-content-start">
                            <CButton color="dark" className="px-4 fw-medium text-white">
                                Actualizar Contraseña
                            </CButton>
                        </div>
                    </CForm>
                )}

                {/* TAB 3: SESIONES ACTIVAS */}
                {activeTab === 'sessions' && <SessionsTab />}
            </CCardBody>
        </CCard>
    );
};

export default UserProfilePage;